export default "__VITE_ASSET__ae789475__"